import React from "react";
import PrivacyData from "../assets/privacy/cookie-privacy.json";
import { useInView } from 'react-intersection-observer';
import newsLetter from "../assets/newsletter/newsletter.webm";
import newsLetter1 from "../assets/newsletter/newsletter.gif";
import newsLetter2 from "../assets/newsletter/newsletter.mp4";
import newsLetterMobile from "../assets/newsletter/newsletter1.webm";
import newsLetterMobile1 from "../assets/newsletter/newsletter1.gif";
import newsLetterMobile2 from "../assets/newsletter/newsletter1.mp4";
const itemWithId3 = PrivacyData.find((item) => item.id === 3);


export default function Newsletter() {

  const [ref, inView] = useInView({
    triggerOnce: true, // Load the video only once when it comes into view
    threshold: 0.2, // Adjust the threshold as needed
  });

  return (
    <>
      <div className="pop-up-container">
        <div ref={ref}>
          {inView ? (
            <>
              <video className="d-none d-md-block" width="100%" playsInline autoPlay muted loop>
                <source src={newsLetter} className="img-fluid" type="video/webm" />
                <source src={newsLetter1} className="img-fluid" type="video/gif" />
                <source src={newsLetter2} className="img-fluid" type="video/mp4" />
                Your browser does not support HTML5 video.
              </video>
              <video className="d-block d-md-none" width="100%" playsInline autoPlay muted loop>
                <source src={newsLetterMobile} className="img-fluid" type="video/webm" />
                <source src={newsLetterMobile1} className="img-fluid" type="video/gif" />
                <source src={newsLetterMobile2} className="img-fluid" type="video/mp4" />
                Your browser does not support HTML5 video.
              </video>
            </>
          ) : (
            <div className="background-newsletter bg-black bg-opacity-75">
              <div className="background-sfumato-bottom" style={{ "height": "30rem" }}></div>
            </div>
          )}
        </div>
        <div className="container text-overlay-2 text-center mt-5">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-12 text-center">
              <h2 className="promo-title m-0 p-0 text-light lh-1 fw-bold">
                Rimani sempre aggiornato sulle nostre promozioni
              </h2>
            </div>
            <div className="col-12 text-center mb-5 mt-4 my-sm-4 mt-md-4 mb-md-5 my-lg-4 my-xl-5">
              <div className="text-center col-12">
              <button className="bg-default border-0 text-light button-rounded mb-5 py-2 px-4 fw-normal fs-5"  onClick={(e) => { e.preventDefault(); window.location.href = '#contact-form'; }}>Contattaci</button>
            </div>
              {/* <form className="d-flex justify-content-center align-items-center" onSubmit={handleSubmit}>
                <div className="container">
                  <div className="row d-flex justify-content-center align-items-center">

                    <div className="col-md-6 col-10">
                      <input className="bg-white form-control rounded-pill" pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$" type="text" value={email} id="email" name="email" autoComplete="email" placeholder="Inserisci qui la tua mail" onChange={handleEmailChange} required />
                    </div>

                    <div className="col-10 d-flex justify-content-center my-3 my-sm-3 my-md-3 my-lg-4">
                      <label className="switch me-3">
                        <input type="checkbox" id="consensoDati" className="form-check-input" required />
                        <span className="slider round" />
                      </label>
                      <a href="/" className="text-light text-decoration-none" data-bs-toggle="modal" data-bs-target="#modalNewsletter"><span className="text-danger">*</span> CONSENSO DATI</a>
                    </div>
                    {!isSent &&
                      <div className="col-md-3 col-10 d-flex justify-content-center align-items-center">
                        <button type="submit" className="btn-default rounded px-4 py-1 py-md-2 px-md-5 text-uppercase">Invia</button>
                      </div>
                    }
                    {isSent &&
                      <div className="col-12 col-sm-10 col-md-8 col-lg-6 alert text-center bg-light p-0 bg-opacity-50" role="alert" id="newsletterInviato">
                        <div className="bg-success bg-opacity-50 m-0 p-2">
                          <p className="fw-bold text-center m-0 text-shadow-none">
                            La tua richiesta è stata inoltrata con successo!
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </form> */}
              <div className="container">
                <div className="row d-flex justify-content-center align-items-center">
                  <div className="modal fade" id="modalNewsletter" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable d-flex justify-content-center align-items-center">
                      <div className="modal-content" style={{ "width": "95%", "height": "70%" }}>
                        <div className="modal-header text-center">
                          <h6 className="modal-title text-default fw-bold fs-5" id="staticBackdropLabel">{itemWithId3.title}</h6>
                          <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-start text-shadow-none">
                          <div dangerouslySetInnerHTML={{ __html: itemWithId3.content }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


